<!-- ========================= -->
<!-- JS UNIFICADO COMPLETO -->
<!-- ========================= -->

  let i = 0, currentText = "", currentEl = null, callbackFn = null;
let selectedPath = "";
let queenAnswer = null;
let giovanniAnswer = null;
let thirdAnswer = null;

  function typeWriterGeneric(text, elId, speed = 40, cb = null) {
    currentText = text;
    currentEl = document.getElementById(elId);
    currentEl.innerHTML = "";
    i = 0; callbackFn = cb;
    (function step() {
      if (i < currentText.length) {
        const ch = currentText.charAt(i++);
        currentEl.innerHTML += ch === "\n" ? "<br>" : ch;
        setTimeout(step, speed);
      } else if (callbackFn) {
        callbackFn();
      }
    })();
  }

  // Al cargar, inicia Sección 1
  window.addEventListener("DOMContentLoaded", () => {
    typeWriterGeneric(
      "Viena - 1791.\nMozart, al borde de la muerte, debe completar su Réquiem si quiere alcanzar la gloria eterna...\n¿quieres ayudarle?",
      "typewriter-text"
    );
  });

  function startAdventure() {
    document.getElementById("cap1").classList.add("fade-out");
    setTimeout(() => {
      document.getElementById("cap1").style.display = "none";
      document.getElementById("cap2").style.display = "block";
      typeWriterGeneric(
        "Elige cómo quieres que Mozart se enfrente a esta nueva realidad.",
        "typewriter-text-2",
        40,
        () => document.getElementById("character-options").style.display = "flex"
      );
    }, 800);
  }

  function choosePath(path) {
    selectedPath = path;
    document.getElementById("cap2").classList.add("fade-out");
    setTimeout(() => {
      document.getElementById("cap2").style.display = "none";
      document.getElementById("cap3-" + path).style.display = "block";
      typeWriterGeneric(
        "Mozart " + path.charAt(0).toUpperCase() + path.slice(1) +
        " ha dejado atrás el mundo de los vivos y de los muertos...\ny ahora camina por un sueño donde su obra murmura con voz propia.",
        "typewriter-scene3-" + path
      );
    }, 800);
  }

  function startQueenScene(variant) {
    hideAll();
    document.getElementById("cap3-" + variant).style.display = "none";
    const sceneId = "cap3a-" + variant;
    document.getElementById(sceneId).style.display = "block";
    typeWriterGeneric(
      "Mozart se adentra en una arquitectura imposible: el castillo de la Reina de la Noche, suspendido entre la realidad y la invocación. Ella lo observa con ojos de estrella muerta.",
      "typewriter-scene3a-" + variant
    );
  }

  function startQueenScene2() {
    const a = "cap3a-" + selectedPath, b = "cap3b-" + selectedPath;
    document.getElementById(a).classList.add("fade-out");
    setTimeout(() => {
      document.getElementById(a).style.display = "none";
      document.getElementById(b).style.display = "block";
      typeWriterGeneric(
        "REINA DE LA NOCHE —“¿Por qué vuelves, Wolfgang?”\n" +
        "MOZART —“Aún no he terminado mi Réquiem y Dios me ha pedido que deje un pasaje escrito antes de morir.”\n" +
        "REINA DE LA NOCHE —“¿Buscas luz… en mí?”\n" +
        "MOZART —“La luz siempre la has portado, querida Reina. El 'Sanctus', canto de alabanza, debe nacer del lugar más oscuro y el sitio es éste.”\n" +
        "REINA DE LA NOCHE —“Entonces, pregúntame... pero recuerda que las respuestas transforman.”",
        "typewriter-scene3b-" + selectedPath,
        40,
        () => document.getElementById("queen-options-" + selectedPath).style.display = "block"
      );
    }, 800);
  }

  function selectQueenAnswer(opt) {
    queenAnswer = opt;
    document.getElementById("queen-options-" + selectedPath).style.display = "none";
    const ans = [
      'REINA —“La que no se arrodilla. La que fue hecha para mirar de frente al fuego sin cerrar los ojos. El cielo no teme a la oscuridad. Teme a la luz que no puede controlar.”',
      'REINA —“Como un eco bajo el agua. Como una nota que se niega a morir. Hay belleza que no necesita testigos, Wolfgang. Pero aun así, deja huella.”',
      'REINA —“Si te atreves a morir con los ojos abiertos, sí. El Sanctus no es un himno. Es un salto. Y sólo brilla quien decide no volverse invisible en el descenso.”'
    ][opt-1];
    typeWriterGeneric(ans, "typewriter-scene3b-" + selectedPath, 40, () => {
      const btn = document.createElement("a");
      btn.className = "mozart-button";
      btn.textContent = "Continuar";
      btn.onclick = goToSection4;
      document.getElementById("cap3b-" + selectedPath).appendChild(btn);
    });
  }

  function goToSection4() {
    document.getElementById("cap3b-" + selectedPath).style.display = "none";
    document.getElementById("cap4").style.display = "block";
    let imgSrc, txt;
    if (queenAnswer === 1) {
      imgSrc = "https://cdn.shopify.com/s/files/1/0866/5366/5545/files/objeto_gorro.png?v=1753113587";
      txt = "La Reina de la Noche ha entregado a Mini Mozart un objeto:\nGORRO";
    } else if (queenAnswer === 2) {
      imgSrc = "https://cdn.shopify.com/s/files/1/0866/5366/5545/files/objeto_hoodie.png?v=1753113957";
      txt = "La Reina de la Noche ha entregado a Mini Mozart un objeto:\nHOODIE";
    } else {
      imgSrc = "https://cdn.shopify.com/s/files/1/0866/5366/5545/files/objeto.png?v=1753112715";
      txt = "La Reina de la Noche ha entregado a Mini Mozart un objeto:\nCAN-SHAPED GLASS";
    }
    document.getElementById("object-image").src = imgSrc;
    typeWriterGeneric(txt, "typewriter-scene4", 40, () => {
      document.getElementById("continue-to-cap5").style.display = "inline-block";
    });
  }

  function goToSection5() {
    const id = "cap5-" + selectedPath + "-" + queenAnswer;
    document.getElementById("cap4").style.display = "none";
    document.getElementById(id).style.display = "block";
    typeWriterGeneric(
      "Al salir del castillo, Mozart se encuentra con una figura en las sombras del jardín...\nDon Giovanni.",
      "typewriter-scene5-" + selectedPath + "-" + queenAnswer
    );
  }

  function goToSection5A() {
    const cur = "cap5-" + selectedPath + "-" + queenAnswer;
    const nxt = "cap5a-" + selectedPath + "-" + queenAnswer;
    document.getElementById(cur).style.display = "none";
    document.getElementById(nxt).style.display = "block";
    typeWriterGeneric(
      "—DON GIOVANNI: “¿Qué haces aquí, Wolfgang?”\n" +
      "—MOZART: “Busco redención.”\n" +
      "—DON GIOVANNI: “Entonces no la encontrarás en mí.”\n" +
      "—MOZART: “Me temo que Dios te ha puesto en mi camino, 'dissoluto punito'. El Benedictus debe pasar por el juicio de quien nunca pidió perdón. Dime...”",
      "typewriter-scene5a-" + selectedPath + "-" + queenAnswer,
      40,
      () => document.getElementById("complement-options-" + selectedPath + "-" + queenAnswer).style.display = "block"
    );
  }

function selectGiovanniQuestion(q) {

  giovanniAnswer = q;

  const cur = "cap5a-" + selectedPath + "-" + queenAnswer;
  const nxt = "cap5b-" + selectedPath + "-" + queenAnswer;
    document.getElementById(cur).style.display = "none";
    document.getElementById(nxt).style.display = "block";
    const text = [
      "DON GIOVANNI: “No. La culpa es un anzuelo para los débiles. Yo sólo viví. Deseé, gocé, caí... ¿y qué? ¡Mi condena no nació de la culpa, sino del silencio que vino después!”",
      "DON GIOVANNI: “Vi lo que siempre fue: un eco de mi voz en el vacío. No hay fuego. No hay castigo. Solo tu nombre, repetido hasta olvidarse.”",
      "DON GIOVANNI: “No. Pero elegiría que al menos una de mis víctimas me perdonara. Porque en el juicio eterno… lo único que no puedes invocar es el perdón que nunca pediste.”"
    ][q-1];
    typeWriterGeneric(text, "typewriter-scene5b-" + selectedPath + "-" + queenAnswer);
  }

function goToSection6() {

  const cur = "cap5b-" + selectedPath + "-" + queenAnswer;
  const nxt = "cap6-" + selectedPath + "-" + queenAnswer;

  document.getElementById(cur).style.display = "none";
  document.getElementById(nxt).style.display = "block";
}

function goToSection7() {

  const cur = "cap6-" + selectedPath + "-" + queenAnswer;
  const nxt = "cap7-" + selectedPath + "-" + queenAnswer + "-" + giovanniAnswer;

  const currentEl = document.getElementById(cur);
  const nextEl = document.getElementById(nxt);

  if (currentEl) currentEl.style.display = "none";
  if (!nextEl) return;

  nextEl.style.display = "block";

  typeWriterGeneric(
    "Mozart avanza hacia un nuevo encuentro decisivo...",
    "typewriter-scene7-" + selectedPath + "-" + queenAnswer + "-" + giovanniAnswer
  );
}

function goToSection7A() {
  const cur = "cap7-" + selectedPath + "-" + queenAnswer + "-" + giovanniAnswer;
  const nxt = "cap7a-" + selectedPath + "-" + queenAnswer + "-" + giovanniAnswer;

  document.getElementById(cur).style.display = "none";
  document.getElementById(nxt).style.display = "block";

  typeWriterGeneric(
    "El personaje inclina la cabeza y responde...",
    "typewriter-scene7a-" + selectedPath + "-" + queenAnswer + "-" + giovanniAnswer,
    40,
    () => {
      document.getElementById(
        "third-options-" + selectedPath + "-" + queenAnswer + "-" + giovanniAnswer
      ).style.display = "block";
    }
  );
}

function selectThirdAnswer(opt) {
  thirdAnswer = opt;
  goToFinalProduct();
}

function goToFinalProduct() {

  const finalId =
    selectedPath + "-" +
    queenAnswer + "-" +
    giovanniAnswer + "-" +
    thirdAnswer;

  document.querySelectorAll("section").forEach(s => s.style.display = "none");
  document.getElementById("capFinal").style.display = "block";

  const productMap = {
    "skeleton-1-1-1": {
      image: "URL_IMAGEN_1",
      url: "/products/producto-ejemplo"
    }
  };

  if (productMap[finalId]) {
    document.getElementById("final-product-image").src = productMap[finalId].image;
    document.getElementById("buy-now-btn").href = productMap[finalId].url;
  }
}
  function hideAll() {
    document.querySelectorAll(".mozart-variant, #cap4").forEach(el => el.style.display = "none");
  }
